import { configureStore } from '@reduxjs/toolkit'
import documentReducer from './documentReducer'
import { languageReducer } from './languageReducer'
import memberReducer from './memberReducer'
import memberAccessReducer from './memberAccessReducer'
import noticeReducer from './noticeReducer'
import authReducer from './authReducer'
import accountLinkReducer from './accountLinkReducer'
import accountSearchReducer from './accountSearchReducer'
import accountSearchLinkReducer from './accountSearchLinkReducer'
import feedBackReducer from './feedBackReducer'
import sendFeedbackReducer from './sendFeedbackReducer'
import bannerReducer from './bannerReducer'
const allReducers = configureStore({
  reducer: {
    language: languageReducer,
    member: memberReducer,
    memberAccess: memberAccessReducer,
    notices: noticeReducer,
    documents: documentReducer,
    auth: authReducer,
    accountLinkReducer,
    accountSearchReducer,
    accountSearchLinkReducer,
    sendFeedbackReducer,
    flag: feedBackReducer,
    bannerReducer
  }
})

export default allReducers
